import React from 'react'
import './ServiceCard.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function ServiceCard({ title, icon}) {
    return (
        <div className="serviceCard">
            <div className="service__photo">
                <FontAwesomeIcon icon={icon} />
            </div>
            <h4>{title}</h4>
            <p>Aliquip commodo est magna veniam sint in non. Adipisicing consequat consequat non culpa aliquip sunt Lorem quis. Aliquip dolor minim magna deserunt.</p>
        </div>
    )
}

export default ServiceCard
